import { render, staticRenderFns } from "./mod4.vue?vue&type=template&id=2ed656e7&scoped=true&"
import script from "./mod4.vue?vue&type=script&lang=js&"
export * from "./mod4.vue?vue&type=script&lang=js&"
import style0 from "./mod4.vue?vue&type=style&index=0&id=2ed656e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed656e7",
  null
  
)

export default component.exports